var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckCircle32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 16C6 10.4772 10.4772 6 16 6C21.5201 6.00671 25.9933 10.4799 26 16C26 21.5228 21.5228 26 16 26C10.4772 26 6 21.5228 6 16ZM21.0303 14.0303C21.3232 13.7374 21.3232 13.2626 21.0303 12.9697C20.7374 12.6768 20.2626 12.6768 19.9697 12.9697L15 17.9393L13.0303 15.9697C12.7374 15.6768 12.2626 15.6768 11.9697 15.9697C11.6768 16.2626 11.6768 16.7374 11.9697 17.0303L14.4697 19.5303C14.7626 19.8232 15.2374 19.8232 15.5303 19.5303L21.0303 14.0303Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle32);
export default __webpack_public_path__ + "static/media/icon-check-circle-32.697424d3.svg";
export { ForwardRef as ReactComponent };